module.exports = __webpack_public_path__ + "static/media/1POLICY24.1e6b9060.jpg";